import { useMemo, useState } from 'react';
import { useMechanicAuth } from '../MechanicAuthContext';
import { invApi } from '../components/inventory/invApi';
import { useInventoryContext } from '../components/inventory/useInventoryContext';
import { ReceiveInvoiceButton } from '../components/inventory/ReceiveInvoiceButton';
import { ItemsTab } from '../components/inventory/ItemsTab';
import { ReviewsTab } from '../components/inventory/ReviewsTab';
import { RestockTab } from '../components/inventory/RestockTab';
import { SuppliersTab } from '../components/inventory/SuppliersTab';
import { CategoriesTab } from '../components/inventory/CategoriesTab';
import { ReportTab } from '../components/inventory/ReportTab';

export default function InventoryPage() {
  const { token } = useMechanicAuth();
  const api = useMemo(() => invApi(token), [token]);
  const { ctx, reload } = useInventoryContext(api);
  const [tab, setTab] = useState('items');
  const [refreshKey, setRefreshKey] = useState(0);
  const admin = ctx.can_see_costs;

  const tabs = [
    ['items', 'Pièces'],
    ['reviews', `À confirmer${ctx.pending_reviews ? ` (${ctx.pending_reviews})` : ''}`],
    ...(admin ? [['restock', `À commander${ctx.to_restock ? ` (${ctx.to_restock})` : ''}`], ['suppliers', 'Fournisseurs'], ['categories', 'Marges'], ['report', 'Rapport']] : []),
  ];
  const refresh = () => { reload(); setRefreshKey(k => k + 1); };

  return (
    <div className="space-y-5 pb-10 px-4 lg:px-6 pt-2" data-testid="inventory-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-white">Inventaire de l'atelier</h1>
          <p className="text-sm text-slate-400 mt-1">Il se met à jour tout seul avec les factures fournisseurs et les bons de travail.</p>
        </div>
        <ReceiveInvoiceButton api={api} onDone={refresh} />
      </div>
      <div className="flex gap-1 overflow-x-auto">
        {tabs.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${tab === k ? 'bg-amber-500 text-black font-semibold' : 'text-slate-400 hover:text-white bg-slate-900'}`} data-testid={`inventory-tab-${k}`}>{l}</button>
        ))}
      </div>
      {tab === 'items' && <ItemsTab api={api} canSeeCosts={admin} refreshKey={refreshKey} />}
      {tab === 'reviews' && <ReviewsTab api={api} canSeeCosts={admin} onChange={reload} />}
      {tab === 'restock' && admin && <RestockTab api={api} />}
      {tab === 'suppliers' && admin && <SuppliersTab api={api} />}
      {tab === 'categories' && admin && <CategoriesTab api={api} fallback={ctx.parts_markup_percent || 0} />}
      {tab === 'report' && admin && <ReportTab api={api} token={token} />}
    </div>
  );
}
